// import React, { useContext, useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
// import Select from "react-select";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";

// const colors = [
//   "#0000FF",
//   "#ff7687",
//   "#f87171", // red-400
//   "#fb923c", // orange-400
//   "#facc15", // yellow-400
//   "#4ade80", // green-400
//   "#34d399", // emerald-400
//   "#2dd4bf", // teal-400
//   "#38bdf8", // sky-400
//   "#60a5fa", // blue-400
//   "#818cf8", // indigo-400
//   "#a78bfa", // violet-400
//   "#e879f9", // fuchsia-400
//   "#f472b6", // pink-400
//   "#f9a8d4", // rose-400
//   "#c084fc", // purple-400
//   "#fcd34d", // amber-400
//   "#86efac", // lime-400
//   "#5eead4", // cyan-400
//   "#67e8f9", // light blue
// ];

// const LeadLabel = () => {
//   const { user } = useContext(AuthContext);

//   // Existing state
//   const [leadLabels, setLeadLabels] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFields, setShowFields] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [labelForm, setLabelForm] = useState({ name: "", color: colors[0] });
//   const [editingLabel, setEditingLabel] = useState(null);
//   const [confirmDeleteId, setConfirmDeleteId] = useState(null);

//   // Assignment state
//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [assigningLabel, setAssigningLabel] = useState(null);
//   const [assignedUsers, setAssignedUsers] = useState([]);
//   const [percentageError, setPercentageError] = useState("");

//   const token = localStorage.getItem("token");
//   const companyId =
//     user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//   const createdById = user?.id;

//   const fetchLeadLabels = useCallback(async () => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/api/projectName/company/${companyId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setLeadLabels(response.data);
//     } catch (error) {
//       console.error("Error fetching lead labels", error);
//     }
//   }, [companyId, token]);

//   useEffect(() => {
//     fetchLeadLabels();
//   }, [fetchLeadLabels]);

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       try {
//         const response = await fetch(
//           `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`,
//           {
//             method: "GET",
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         if (!response.ok)
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   const handleSave = async () => {
//     try {
//       if (editingLabel) {
//         await axios.put(
//           `${API_URL}/api/projectName/${editingLabel.id}`,
//           { ...labelForm, companyId },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       } else {
//         await axios.post(
//           `${API_URL}/api/projectName`,
//           { ...labelForm, companyId, createdById },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }
//       closeModal();
//       fetchLeadLabels();
//     } catch (error) {
//       console.error("Failed to save label", error);
//     }
//   };

//   const handleAssignClick = (label) => {
//     setAssigningLabel({
//       ...label,
//       isEqualDistribution: label.isEqualDistribution || false
//     });
//     setAssignedUsers(label.allocatedTo || []);
//     setPercentageError("");
//     setShowAssignModal(true);
//   };

//   const handleAssignedUsersChange = (selectedOptions) => {
//     const newAssignedUsers = selectedOptions.map((option) => {
//       const existing = assignedUsers.find((u) => u.id === option.value);
//       return (
//         existing || {
//           id: option.value,
//           name: option.label,
//           percentage: 0,
//         }
//       );
//     });

//     setAssignedUsers(newAssignedUsers);

//     // Calculate total percentage
//     const total = newAssignedUsers.reduce(
//       (sum, user) => sum + (Number(user.percentage) || 0),
//       0
//     );
//     setPercentageError(
//       total > 100 ? "Total percentage cannot exceed 100%." : ""
//     );
//   };

//   const handlePercentageChange = (id, value) => {
//     const num = Number(value);
//     const updated = assignedUsers.map((u) =>
//       u.id === id ? { ...u, percentage: num } : u
//     );
//     const total = updated.reduce(
//       (sum, u) => sum + (Number(u.percentage) || 0),
//       0
//     );
//     if (total > 100) {
//       setPercentageError("Total percentage cannot exceed 100%.");
//     } else {
//       setPercentageError("");
//     }
//     setAssignedUsers(updated);
//   };

//   const handleAssignSave = async () => {
//     const total = assignedUsers.reduce(
//       (sum, u) => sum + (Number(u.percentage) || 0),
//       0
//     );
//     if (total > 100) return;

//     try {
//       await axios.put(
//         `${API_URL}/api/projectName/assignTo/${assigningLabel.id}`,
//         {
//           allocatedTo: assignedUsers.map((user) => ({
//             id: user.id,
//             name: user.name,
//             percentage: Number(user.percentage),
//           })),
//           isEqualDistribution: assigningLabel.isEqualDistribution
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setShowAssignModal(false);
//       setAssigningLabel(null);
//       fetchLeadLabels();
//     } catch (err) {
//       console.error("Error saving allocations", err);
//     }
//   };

//   const closeAssignModal = () => {
//     setShowAssignModal(false);
//     setAssigningLabel(null);
//     setAssignedUsers([]);
//     setPercentageError("");
//   };

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`${API_URL}/api/projectName/${confirmDeleteId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setConfirmDeleteId(null);
//       fetchLeadLabels();
//     } catch (error) {
//       console.error("Delete failed", error);
//     }
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setLabelForm({ name: "", color: colors[0] });
//     setEditingLabel(null);
//   };

//   return (
//     <div className="p-2 bg-gray-100 shadow-lg dark:bg-gray-900 dark:text-white">
//       {/* Header */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
//         <h2 className="text-xl font-bold">Project Name</h2>
//         <div className="flex justify-end items-center gap-2 w-full sm:w-auto">
//           <button
//             onClick={() => setShowModal(true)}
//             className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2 text-sm sm:text-base"
//           >
//             <FaPlus /> Add
//           </button>

//           <button
//             onClick={() => setShowFields(!showFields)}
//             className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2 text-sm sm:text-base"
//           >
//             <FaSearch />
//             {showFields ? "Close" : "Search"}
//           </button>
//         </div>
//       </div>

//       {/* Search fields */}
//       {showFields && (
//         <div className="mb-4 flex flex-col sm:flex-row gap-2 items-start sm:items-center">
//           <input
//             type="text"
//             placeholder="Search lead label..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="border px-3 py-2 rounded w-full sm:w-1/3 dark:bg-gray-800 dark:text-white"
//           />

//           <div className="flex gap-2 w-full sm:w-auto">
//             <button
//               onClick={async () => {
//                 try {
//                   const res = await axios.get(
//                     `${API_URL}/api/projectName/search/${companyId}?name=${searchTerm}`,
//                     { headers: { Authorization: `Bearer ${token}` } }
//                   );
//                   setLeadLabels(res.data);
//                 } catch (err) {
//                   console.error("Search failed", err);
//                 }
//               }}
//               className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full sm:w-auto"
//             >
//               Search
//             </button>

//             <button
//               onClick={() => {
//                 setSearchTerm("");
//                 fetchLeadLabels();
//               }}
//               className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 w-full sm:w-auto"
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="w-full border">
//           <thead className="bg-gray-50 dark:bg-gray-800 dark:text-white">
//             <tr>
//               <th className="px-4 py-2 text-left">Project</th>
//               <th className="px-4 py-2 text-left">Assigned To</th>
//               <th className="px-4 py-2 text-left">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {leadLabels.map((label) => (
//               <tr key={label.id} className="border-t">
//                 <td className="px-4 py-2">
//                   <span
//                     className="inline-block px-3 py-1 rounded-full text-white"
//                     style={{ backgroundColor: label.color || "#6b7280" }}
//                   >
//                     {label.name}
//                   </span>
//                 </td>

//                 <td className="px-4 py-2">
//                   {label.allocatedTo?.length ? (
//                     <div className="flex flex-wrap gap-1">
//                       {label.allocatedTo.map((u) => (
//                         <span
//                           key={u.id}
//                           className="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded text-xs flex items-center gap-1"
//                         >
//                           {u.name}{" "}
//                           <span className="text-gray-500">
//                             ({u.percentage}%)
//                           </span>
//                         </span>
//                       ))}
//                       {label.isEqualDistribution && (
//                         <span className="bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded dark:bg-green-900 dark:text-green-200">
//                           Equal
//                         </span>
//                       )}
//                     </div>
//                   ) : (
//                     <span className="text-sm text-gray-500">—</span>
//                   )}
//                   <button
//                     onClick={() => handleAssignClick(label)}
//                     className="ml-2 text-green-600 hover:text-green-800 inline-flex items-center"
//                     title="Assign users"
//                   >
//                     <FaPlus />
//                   </button>
//                 </td>

//                 <td className="px-4 py-2 flex gap-4">
//                   <button
//                     onClick={() => {
//                       setLabelForm({ name: label.name, color: label.color });
//                       setEditingLabel(label);
//                       setShowModal(true);
//                     }}
//                     className="text-yellow-500 hover:text-yellow-700"
//                   >
//                     <FaEdit />
//                   </button>
//                   <button
//                     onClick={() => setConfirmDeleteId(label.id)}
//                     className="text-red-600 hover:text-red-800"
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Label Create/Edit Modal */}
//       {showModal && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto dark:bg-gray-800 dark:text-white">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-bold">
//                 {editingLabel ? "Edit" : "Create"} Label
//               </h2>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>
//             <input
//               type="text"
//               value={labelForm.name}
//               onChange={(e) =>
//                 setLabelForm({ ...labelForm, name: e.target.value })
//               }
//               className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-800 dark:text-white"
//               placeholder="Label Name"
//             />
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                 Color
//               </label>
//               <div className="flex flex-wrap gap-2">
//                 {colors.map((color) => (
//                   <button
//                     key={color}
//                     onClick={() => setLabelForm({ ...labelForm, color })}
//                     className={`w-8 h-8 rounded-full cursor-pointer border-2 transition-all ${
//                       labelForm.color === color
//                         ? "border-black dark:border-white scale-110"
//                         : "border-transparent hover:border-gray-300 dark:hover:border-gray-500"
//                     }`}
//                     style={{ backgroundColor: color }}
//                     aria-label={`Select color ${color}`}
//                   />
//                 ))}
//               </div>
//             </div>
//             <div className="flex justify-end gap-2 mt-6">
//               <button
//                 onClick={closeModal}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSave}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
//                 disabled={!labelForm.name.trim()}
//               >
//                 {editingLabel ? "Update" : "Create"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirm Delete Modal */}
//       {confirmDeleteId && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="bg-white rounded-lg p-6 w-full max-w-sm mx-4 dark:bg-gray-800 dark:text-white">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-lg font-bold">
//                 Confirm Deletion
//               </h2>
//               <button
//                 onClick={() => setConfirmDeleteId(null)}
//                 className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>
//             <p className="mb-6">Are you sure you want to delete this label?</p>
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setConfirmDeleteId(null)}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Assign Users Modal */}
//       {showAssignModal && (
//   <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//     <div className="bg-white rounded-lg w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto dark:bg-gray-800 dark:text-white relative">
//       {/* Sticky header with close button */}
//       <div className="sticky top-0 bg-white dark:bg-gray-800 z-10 p-6 pb-4 border-b border-gray-200 dark:border-gray-700">
//         <div className="flex justify-between items-center">
//           <h2 className="text-xl font-bold">
//             Assign Users to {assigningLabel?.name}
//           </h2>
//           <button
//             onClick={closeAssignModal}
//             className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-6 w-6"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </button>
//         </div>
//       </div>

//       {/* Scrollable content */}
//       <div className="p-6 pt-4">
//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//             Select Users
//           </label>
//           <Select
//             isMulti
//             name="assignedUsers"
//             options={users.map((user) => ({
//               value: user.id,
//               label: `${user.fname} ${user.lname}`,
//             }))}
//             value={assignedUsers.map((user) => ({
//               value: user.id,
//               label: user.name,
//             }))}
//             onChange={handleAssignedUsersChange}
//             className="w-full"
//             classNamePrefix="select"
//             styles={{
//               control: (base, state) => ({
//                 ...base,
//                 minHeight: "42px",
//                 borderRadius: "0.375rem",
//                 borderColor: "#d1d5db",
//                 backgroundColor: document.documentElement.classList.contains("dark")
//                   ? "#374151"
//                   : "white",
//                 color: document.documentElement.classList.contains("dark")
//                   ? "white"
//                   : "black",
//                 boxShadow: state.isFocused ? "0 0 0 1px #60a5fa" : "none",
//                 "&:hover": {
//                   borderColor: "#9ca3af",
//                 },
//               }),
//               menu: (base) => ({
//                 ...base,
//                 borderRadius: "0.375rem",
//                 marginTop: 4,
//                 backgroundColor: document.documentElement.classList.contains("dark")
//                   ? "#1f2937"
//                   : "white",
//               }),
//               option: (base, { isFocused, isSelected }) => ({
//                 ...base,
//                 backgroundColor: isFocused
//                   ? document.documentElement.classList.contains("dark")
//                     ? "#4b5563"
//                     : "#f3f4f6"
//                   : isSelected
//                   ? "#60a5fa"
//                   : "transparent",
//                 color: isSelected ? "white" : "inherit",
//               }),
//             }}
//           />
//         </div>

//         {assignedUsers.length > 0 && (
//           <div className="mb-6">
//             <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
//               <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
//                 Allocation Percentages
//               </h3>
//               <div className="flex items-center gap-2">
//                 <label htmlFor="equalToggle" className="text-sm font-medium text-gray-700 dark:text-gray-300">
//                   Equal Distribution:
//                 </label>
//                 <div className="relative inline-block w-10 align-middle select-none">
//                   <input
//                     type="checkbox"
//                     id="equalToggle"
//                     checked={assigningLabel?.isEqualDistribution || false}
//                     onChange={(e) => {
//                       const isEqual = e.target.checked;
//                       setAssigningLabel({
//                         ...assigningLabel,
//                         isEqualDistribution: isEqual
//                       });
                      
//                       if (isEqual) {
//                         const equalPercentage = Math.floor(100 / assignedUsers.length);
//                         const remainder = 100 % assignedUsers.length;
//                         const updatedUsers = assignedUsers.map((user, index) => ({
//                           ...user,
//                           percentage: index === 0 ? equalPercentage + remainder : equalPercentage
//                         }));
//                         setAssignedUsers(updatedUsers);
//                       }
//                       setPercentageError("");
//                     }}
//                     className="sr-only"
//                   />
//                   <label
//                     htmlFor="equalToggle"
//                     className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors ${
//                       assigningLabel?.isEqualDistribution ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'
//                     }`}
//                   >
//                     <span
//                       className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform ${
//                         assigningLabel?.isEqualDistribution ? 'translate-x-4' : 'translate-x-0'
//                       }`}
//                     />
//                   </label>
//                 </div>
//               </div>
//             </div>

//             <div className="space-y-3 max-h-64 overflow-y-auto pr-2">
//               {assignedUsers.map((user) => (
//                 <div
//                   key={user.id}
//                   className="bg-gray-50 p-3 rounded-md dark:bg-gray-700"
//                 >
//                   <div className="flex justify-between items-center mb-1">
//                     <h4 className="font-medium">{user.name}</h4>
//                     <button
//                       onClick={() => {
//                         const updatedUsers = assignedUsers.filter(
//                           (u) => u.id !== user.id
//                         );
//                         setAssignedUsers(updatedUsers);
//                         const total = updatedUsers.reduce(
//                           (sum, u) => sum + (Number(u.percentage) || 0),
//                           0
//                         );
//                         setPercentageError(
//                           total > 100
//                             ? "Total percentage cannot exceed 100%."
//                             : ""
//                         );
//                       }}
//                       className="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-5 w-5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M6 18L18 6M6 6l12 12"
//                         />
//                       </svg>
//                     </button>
//                   </div>

//                   <div className="flex items-center gap-2 mt-2">
//                     <input
//                       type="number"
//                       value={
//                         user.percentage === 0 || user.percentage === undefined
//                           ? ""
//                           : user.percentage
//                       }
//                       onChange={(e) =>
//                         handlePercentageChange(user.id, e.target.value)
//                       }
//                       min="0"
//                       max="100"
//                       step="1"
//                       disabled={assigningLabel?.isEqualDistribution}
//                       className={`w-full border rounded px-3 py-1.5 text-sm dark:bg-gray-600 dark:text-white ${
//                         assigningLabel?.isEqualDistribution ? 'opacity-50 cursor-not-allowed' : ''
//                       }`}
//                       placeholder="0-100"
//                     />
//                     <span className="text-gray-500 dark:text-gray-400">%</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="mb-4 p-3 bg-blue-50 rounded-md dark:bg-blue-900/30">
//           <div className="flex justify-between items-center">
//             <span className="font-medium text-gray-700 dark:text-gray-300">
//               Total Allocation:
//             </span>
//             <span
//               className={`font-bold ${
//                 assignedUsers.reduce(
//                   (sum, user) => sum + (Number(user.percentage) || 0),
//                   0
//                 ) > 100
//                   ? "text-red-600 dark:text-red-400"
//                   : "text-gray-700 dark:text-gray-300"
//               }`}
//             >
//               {assignedUsers.reduce(
//                 (sum, user) => sum + (Number(user.percentage) || 0),
//                 0
//               )}
//               %
//             </span>
//           </div>
//           {percentageError && (
//             <p className="text-red-600 text-sm mt-1 dark:text-red-400">
//               {percentageError}
//             </p>
//           )}
//         </div>

//         {/* Sticky footer with action buttons */}
//         <div className="sticky bottom-0 bg-white dark:bg-gray-800 pt-4 pb-2 -mx-6 px-6 border-t border-gray-200 dark:border-gray-700">
//           <div className="flex justify-end gap-2">
//             <button
//               onClick={closeAssignModal}
//               className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleAssignSave}
//               disabled={percentageError !== "" || assignedUsers.length === 0}
//               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 dark:bg-blue-700 dark:hover:bg-blue-800"
//             >
//               Save Assignments
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// )}
//     </div>
//   );
// };

// export default LeadLabel;




import React, { useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import Select from "react-select";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";

const colors = [
  "#0000FF",
  "#ff7687",
  "#f87171", // red-400
  "#fb923c", // orange-400
  "#facc15", // yellow-400
  "#4ade80", // green-400
  "#34d399", // emerald-400
  "#2dd4bf", // teal-400
  "#38bdf8", // sky-400
  "#60a5fa", // blue-400
  "#818cf8", // indigo-400
  "#a78bfa", // violet-400
  "#e879f9", // fuchsia-400
  "#f472b6", // pink-400
  "#f9a8d4", // rose-400
  "#c084fc", // purple-400
  "#fcd34d", // amber-400
  "#86efac", // lime-400
  "#5eead4", // cyan-400
  "#67e8f9", // light blue
];

const LeadLabel = () => {
  const { user } = useContext(AuthContext);

  // Existing state
  const [leadLabels, setLeadLabels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFields, setShowFields] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [labelForm, setLabelForm] = useState({ name: "", color: colors[0] });
  const [editingLabel, setEditingLabel] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  // Assignment state
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [assigningLabel, setAssigningLabel] = useState(null);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [percentageError, setPercentageError] = useState("");

  const token = localStorage.getItem("token");
  const companyId =
    user?.accountType === "COMPANY" ? user?.id : user?.companyId;
  const createdById = user?.id;

  const fetchLeadLabels = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/projectName/company/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setLeadLabels(response.data);
    } catch (error) {
      console.error("Error fetching lead labels", error);
    }
  }, [companyId, token]);

  useEffect(() => {
    fetchLeadLabels();
  }, [fetchLeadLabels]);

  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      try {
        const response = await fetch(
          `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`,
          {
            method: "GET",
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  const handleSave = async () => {
    try {
      if (editingLabel) {
        await axios.put(
          `${API_URL}/api/projectName/${editingLabel.id}`,
          { ...labelForm, companyId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${API_URL}/api/projectName`,
          { ...labelForm, companyId, createdById },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      closeModal();
      fetchLeadLabels();
    } catch (error) {
      console.error("Failed to save label", error);
    }
  };

  const handleAssignClick = (label) => {
    setAssigningLabel({
      ...label,
      isEqualDistribution: label.isEqualDistribution || false
    });
    setAssignedUsers(label.allocatedTo || []);
    setPercentageError("");
    setShowAssignModal(true);
  };

  const handleAssignedUsersChange = (selectedOptions) => {
    const newAssignedUsers = selectedOptions.map((option) => {
      const existing = assignedUsers.find((u) => u.id === option.value);
      return (
        existing || {
          id: option.value,
          name: option.label,
          percentage: 0,
        }
      );
    });

    setAssignedUsers(newAssignedUsers);

    // Calculate total percentage
    const total = newAssignedUsers.reduce(
      (sum, user) => sum + (Number(user.percentage) || 0),
      0
    );
    setPercentageError(
      total > 100 ? "Total percentage cannot exceed 100%." : ""
    );
  };

  const handlePercentageChange = (id, value) => {
    const num = Number(value);
    const updated = assignedUsers.map((u) =>
      u.id === id ? { ...u, percentage: num } : u
    );
    const total = updated.reduce(
      (sum, u) => sum + (Number(u.percentage) || 0),
      0
    );
    if (total > 100) {
      setPercentageError("Total percentage cannot exceed 100%.");
    } else {
      setPercentageError("");
    }
    setAssignedUsers(updated);
  };

  const handleAssignSave = async () => {
    const total = assignedUsers.reduce(
      (sum, u) => sum + (Number(u.percentage) || 0),
      0
    );
    if (total > 100) return;

    try {
      await axios.put(
        `${API_URL}/api/projectName/assignTo/${assigningLabel.id}`,
        {
          allocatedTo: assignedUsers.map((user) => ({
            id: user.id,
            name: user.name,
            percentage: Number(user.percentage),
          })),
          isEqualDistribution: assigningLabel.isEqualDistribution
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowAssignModal(false);
      setAssigningLabel(null);
      fetchLeadLabels();
    } catch (err) {
      console.error("Error saving allocations", err);
    }
  };

  const closeAssignModal = () => {
    setShowAssignModal(false);
    setAssigningLabel(null);
    setAssignedUsers([]);
    setPercentageError("");
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/api/projectName/${confirmDeleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfirmDeleteId(null);
      fetchLeadLabels();
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setLabelForm({ name: "", color: colors[0] });
    setEditingLabel(null);
  };

  return (
    <div className="p-2 bg-[#FAF8FF] shadow-lg cfg-font dark:bg-gray-900 dark:text-white">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
            {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
        <h2 className="text-xl font-bold cfg-heading">Project Name</h2>
        <div className="flex justify-end items-center gap-2 w-full sm:w-auto">
          <button
            onClick={() => setShowModal(true)}
            className="px-2 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2 text-sm sm:text-base"
          >
            <FaPlus /> Add
          </button>

          <button
            onClick={() => setShowFields(!showFields)}
            className="px-2 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2 text-sm sm:text-base"
          >
            <FaSearch />
            {showFields ? "Close" : "Search"}
          </button>
        </div>
      </div>

      {/* Search fields */}
      {showFields && (
        <div className="mb-4 flex flex-col sm:flex-row gap-2 items-start sm:items-center">
          <input
            type="text"
            placeholder="Search lead label..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-[#E5E7EB] px-3 py-2 rounded w-full sm:w-1/3 dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
          />

          <div className="flex gap-2 w-full sm:w-auto">
            <button
              onClick={async () => {
                try {
                  const res = await axios.get(
                    `${API_URL}/api/projectName/search/${companyId}?name=${searchTerm}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                  );
                  setLeadLabels(res.data);
                } catch (err) {
                  console.error("Search failed", err);
                }
              }}
              className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6] w-full sm:w-auto"
            >
              Search
            </button>

            <button
              onClick={() => {
                setSearchTerm("");
                fetchLeadLabels();
              }}
              className="bg-[#F3F4F6] text-[#374151] px-4 py-2 rounded hover:bg-[#E5E7EB] w-full sm:w-auto"
            >
              Clear
            </button>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border border-[#E5E7EB] rounded-lg overflow-hidden">
          <thead className="bg-[#F3F4F6] dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="px-4 py-2 text-left">Project</th>
              <th className="px-4 py-2 text-left">Assigned To</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {leadLabels.map((label) => (
              <tr key={label.id} className="border-t">
                <td className="px-4 py-2">
                  <span
                    className="inline-block px-3 py-1 rounded-full text-white"
                    style={{ backgroundColor: label.color || "#6b7280" }}
                  >
                    {label.name}
                  </span>
                </td>

                <td className="px-4 py-2">
                  {label.allocatedTo?.length ? (
                    <div className="flex flex-wrap gap-1">
                      {label.allocatedTo.map((u) => (
                        <span
                          key={u.id}
                          className="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded text-xs flex items-center gap-1"
                        >
                          {u.name}{" "}
                          <span className="text-gray-500">
                            ({u.percentage}%)
                          </span>
                        </span>
                      ))}
                      {label.isEqualDistribution && (
                        <span className="bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded dark:bg-green-900 dark:text-green-200">
                          Equal
                        </span>
                      )}
                    </div>
                  ) : (
                    <span className="text-sm text-gray-500">—</span>
                  )}
                  <button
                    onClick={() => handleAssignClick(label)}
                    className="ml-2 text-green-600 hover:text-green-800 inline-flex items-center"
                    title="Assign users"
                  >
                    <FaPlus />
                  </button>
                </td>

                <td className="px-4 py-2 flex gap-4">
                  <button
                    onClick={() => {
                      setLabelForm({ name: label.name, color: label.color });
                      setEditingLabel(label);
                      setShowModal(true);
                    }}
                    className="text-[#8B5CF6] hover:text-[#673AB7]"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => setConfirmDeleteId(label.id)}
                    className="text-[#EF4444] hover:text-[#B91C1C]"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Label Create/Edit Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto dark:bg-gray-800 dark:text-white">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold cfg-heading">
                {editingLabel ? "Edit" : "Create"} Label
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <input
              type="text"
              value={labelForm.name}
              onChange={(e) =>
                setLabelForm({ ...labelForm, name: e.target.value })
              }
              className="w-full border border-[#E5E7EB] px-3 py-2 mb-4 rounded dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              placeholder="Label Name"
            />
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Color
              </label>
              <div className="flex flex-wrap gap-2">
                {colors.map((color) => (
                  <button
                    key={color}
                    onClick={() => setLabelForm({ ...labelForm, color })}
                    className={`w-8 h-8 rounded-full cursor-pointer border-2 transition-all ${
                      labelForm.color === color
                        ? "border-black dark:border-white scale-110"
                        : "border-transparent hover:border-gray-300 dark:hover:border-gray-500"
                    }`}
                    style={{ backgroundColor: color }}
                    aria-label={`Select color ${color}`}
                  />
                ))}
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB] dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] disabled:opacity-50"
                disabled={!labelForm.name.trim()}
              >
                {editingLabel ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDeleteId && (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-sm mx-4 dark:bg-gray-800 dark:text-white">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold">
                Confirm Deletion
              </h2>
              <button
                onClick={() => setConfirmDeleteId(null)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <p className="mb-6">Are you sure you want to delete this label?</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setConfirmDeleteId(null)}
                className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB] dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-[#EF4444] text-white rounded hover:bg-[#B91C1C]"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Assign Users Modal */}
      {showAssignModal && (
  <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
    <div className="bg-white rounded-lg w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto dark:bg-gray-800 dark:text-white relative">
      {/* Sticky header with close button */}
      <div className="sticky top-0 bg-white dark:bg-gray-800 z-10 p-6 pb-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold cfg-heading">
            Assign Users to {assigningLabel?.name}
          </h2>
          <button
            onClick={closeAssignModal}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Scrollable content */}
      <div className="p-6 pt-4">
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Select Users
          </label>
          <Select
            isMulti
            name="assignedUsers"
            options={users.map((user) => ({
              value: user.id,
              label: `${user.fname} ${user.lname}`,
            }))}
            value={assignedUsers.map((user) => ({
              value: user.id,
              label: user.name,
            }))}
            onChange={handleAssignedUsersChange}
            className="w-full"
            classNamePrefix="select"
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: "42px",
                borderRadius: "0.375rem",
                borderColor: "#d1d5db",
                backgroundColor: document.documentElement.classList.contains("dark")
                  ? "#374151"
                  : "white",
                color: document.documentElement.classList.contains("dark")
                  ? "white"
                  : "black",
                boxShadow: state.isFocused ? "0 0 0 1px #60a5fa" : "none",
                "&:hover": {
                  borderColor: "#9ca3af",
                },
              }),
              menu: (base) => ({
                ...base,
                borderRadius: "0.375rem",
                marginTop: 4,
                backgroundColor: document.documentElement.classList.contains("dark")
                  ? "#1f2937"
                  : "white",
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isFocused
                  ? document.documentElement.classList.contains("dark")
                    ? "#4b5563"
                    : "#f3f4f6"
                  : isSelected
                  ? "#60a5fa"
                  : "transparent",
                color: isSelected ? "white" : "inherit",
              }),
            }}
          />
        </div>

        {assignedUsers.length > 0 && (
          <div className="mb-6">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
              <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Allocation Percentages
              </h3>
              <div className="flex items-center gap-2">
                <label htmlFor="equalToggle" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Equal Distribution:
                </label>
                <div className="relative inline-block w-10 align-middle select-none">
                  <input
                    type="checkbox"
                    id="equalToggle"
                    checked={assigningLabel?.isEqualDistribution || false}
                    onChange={(e) => {
                      const isEqual = e.target.checked;
                      setAssigningLabel({
                        ...assigningLabel,
                        isEqualDistribution: isEqual
                      });
                      
                      if (isEqual) {
                        const equalPercentage = Math.floor(100 / assignedUsers.length);
                        const remainder = 100 % assignedUsers.length;
                        const updatedUsers = assignedUsers.map((user, index) => ({
                          ...user,
                          percentage: index === 0 ? equalPercentage + remainder : equalPercentage
                        }));
                        setAssignedUsers(updatedUsers);
                      }
                      setPercentageError("");
                    }}
                    className="sr-only"
                  />
                  <label
                    htmlFor="equalToggle"
                    className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors ${
                      assigningLabel?.isEqualDistribution ? 'bg-[#673AB7]' : 'bg-[#E9D5FF] dark:bg-gray-600'
                    }`}
                  >
                    <span
                      className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform ${
                        assigningLabel?.isEqualDistribution ? 'translate-x-4' : 'translate-x-0'
                      }`}
                    />
                  </label>
                </div>
              </div>
            </div>

            <div className="space-y-3 max-h-64 overflow-y-auto pr-2">
              {assignedUsers.map((user) => (
                <div
                  key={user.id}
                  className="bg-gray-50 p-3 rounded-md dark:bg-gray-700"
                >
                  <div className="flex justify-between items-center mb-1">
                    <h4 className="font-medium">{user.name}</h4>
                    <button
                      onClick={() => {
                        const updatedUsers = assignedUsers.filter(
                          (u) => u.id !== user.id
                        );
                        setAssignedUsers(updatedUsers);
                        const total = updatedUsers.reduce(
                          (sum, u) => sum + (Number(u.percentage) || 0),
                          0
                        );
                        setPercentageError(
                          total > 100
                            ? "Total percentage cannot exceed 100%."
                            : ""
                        );
                      }}
                      className="text-[#EF4444] hover:text-[#B91C1C] dark:text-red-400 dark:hover:text-red-300"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>

                  <div className="flex items-center gap-2 mt-2">
                    <input
                      type="number"
                      value={
                        user.percentage === 0 || user.percentage === undefined
                          ? ""
                          : user.percentage
                      }
                      onChange={(e) =>
                        handlePercentageChange(user.id, e.target.value)
                      }
                      min="0"
                      max="100"
                      step="1"
                      disabled={assigningLabel?.isEqualDistribution}
                      className={`w-full border rounded px-3 py-1.5 text-sm dark:bg-gray-600 dark:text-white ${
                        assigningLabel?.isEqualDistribution ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                      placeholder="0-100"
                    />
                    <span className="text-gray-500 dark:text-gray-400">%</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="mb-4 p-3 bg-[#F3E8FF] rounded-md dark:bg-blue-900/30">
          <div className="flex justify-between items-center">
            <span className="font-medium text-gray-700 dark:text-gray-300">
              Total Allocation:
            </span>
            <span
              className={`font-bold ${
                assignedUsers.reduce(
                  (sum, user) => sum + (Number(user.percentage) || 0),
                  0
                ) > 100
                  ? "text-[#EF4444] dark:text-red-400"
                  : "text-gray-700 dark:text-gray-300"
              }`}
            >
              {assignedUsers.reduce(
                (sum, user) => sum + (Number(user.percentage) || 0),
                0
              )}
              %
            </span>
          </div>
          {percentageError && (
            <p className="text-[#EF4444] text-sm mt-1 dark:text-red-400">
              {percentageError}
            </p>
          )}
        </div>

        {/* Sticky footer with action buttons */}
        <div className="sticky bottom-0 bg-white dark:bg-gray-800 pt-4 pb-2 -mx-6 px-6 border-t border-gray-200 dark:border-gray-700">
          <div className="flex justify-end gap-2">
            <button
              onClick={closeAssignModal}
              className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded-md hover:bg-[#E5E7EB] dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
            >
              Cancel
            </button>
            <button
              onClick={handleAssignSave}
              disabled={percentageError !== "" || assignedUsers.length === 0}
              className="px-4 py-2 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] disabled:opacity-50 dark:bg-[#5E35A6] dark:hover:bg-[#4C2D85]"
            >
              Save Assignments
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default LeadLabel;